import { getInitialState, getPath } from "../../utils";

const initialState = {
  featureList: [],
  prevPage: -1,
  nextPage: -1,
  activeFeature: { serviceId: [] },
  activeFilters: { serviceId: [] },
  currentPage: 1,
  dsmEnabledFeatures: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_FEATURE_LIST":
      return setFeatureList(state, action);
    case "SET_ACTIVE_FEATURE":
      return setActiveFeature(state, action);
    case "SET_ACTIVE_FILTERS":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_FEATURE":
      return setCurrentPageFeature(state, action);
    case "RESET_STATE_FEATURE":
      return resetStateFeature(state, action);
    case "SET_DSM_ENABLED_FEATURES":
      return setDSMEnabledFeatures(state, action);
    default:
      return state;
  }
}

const setCurrentPageFeature = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setFeatureList = (state, action) => {
  return {
    ...state,
    featureList: getPath(action.payload, "features", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetStateFeature = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveFeature = (state, action) => {
  return {
    ...state,
    activeFeature: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setDSMEnabledFeatures = (state, action) => {
  return {
    ...state,
    dsmEnabledFeatures: action.payload,
  };
};
